// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

.dropbtn {
  font-size: 1.125rem;
  border: none;
  background-color: transparent;
  padding-left: 0.03em;
  padding-right: 0.03em;
  position: relative;
  max-width: fit-content;
  margin: 0;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: #ffffff;
  min-width: max-content;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  min-width: 400px;
  padding: 2rem;
  margin-left: 0;
  margin-right: 0;
  align-items: center;
  flex-wrap: wrap;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
  display: flex;
}

.dropdown:hover .dropbtn {
  display: flex;
}

.user-initials-profile {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 3.5rem;
  width: 3.5rem;
  font-size: 1.375rem;
  border-radius: 50%;
  background-color: #0b2d71;
  color: #009dd9;
}

.dropdown > button:after {
  display: none;
}

.profile-box-container {
  width: auto;
}

.profile-box-image {
  float: left;
}

.profile-box-content {
  padding-left: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/app/shared/components/cvx-profile/cvx-profile.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAQA;EACE,yBAAA;EACA,iEAAA;EACA,iBAPO;EAQP,gBARO;ACCT;ADUA;EACE,+BAAA;EACA,0EAAA;EACA,iBAdO;EAeP,gBAfO;ACOT;ADWA;EACE,4CAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,kDAAA;ACTF;;ADYA;EACE,8CAAA;ACTF;;ADaA,YAAA;AACA;EACE,kBAxCW;EAyCX,OAAA;ACVF;;ADaA;EACE,mBA5CO;EA6CP,OAAA;ACVF;;ADaA;EACE,mBAhDM;EAiDN,OAAA;ACVF;;ADaA;EACE,eApDO;EAqDP,OAAA;ACVF;;ADaA;EACE,mBAxDO;EAyDP,OAAA;ACVF;;ADaA;EACE,kBA5DM;EA6DN,OAAA;ACVF;;AAtDA;EACI,mBDDI;ECEJ,YAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EAEA,kBAAA;EACA,sBAAA;EACA,SAAA;AAwDJ;;AArDA;EACI,kBAAA;EACA,qBAAA;AAwDJ;;AArDA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,yBCII;EDHJ,sBAAA;EACA,+CAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;AAwDJ;;AArDA;EACI,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AAwDJ;;AArDA;EACI,yBAAA;AAwDJ;;AArDA;EACI,aAAA;AAwDJ;;AApDA;EACI,aAAA;AAuDJ;;AApDA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,cAAA;EACA,aAAA;EAEA,mBD/DK;ECiEL,kBAAA;EACA,yBAAA;EACA,cCnES;ADuHb;;AAjDA;EACI,aAAA;AAoDJ;;AAjDA;EACI,WAAA;AAoDJ;;AAjDA;EACI,WAAA;AAoDJ;;AAjDA;EACI,kBAAA;AAoDJ","sourcesContent":["// FONTS\n$extraLarge: 1.75rem; // 28pt\n$large2: 1.375rem; // 22pt\n$large: 1.125rem; // 18pt\n$normal: 1rem; // 16pt\n$medium: 0.875rem; // 14pt\n$small: 0.75rem; // 12pt\n\n@font-face {\n  font-family: \"GothamBold\";\n  src: url(\"/fonts/gothambold_normal_normal.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n@font-face {\n  font-family: \"GothamNarrowBook\";\n  src: url(\"/fonts/GothamNarrowBook_normal_condensed.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n.cvx-font-gotham-bold {\n  font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.cvx-fon-narrow-bold {\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n}\n\n.cvx-font-gotham-narrow-book {\n  font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.cvx-gothan-medium {\n  font-family: \"GothamMedium\", Arial, sans-serif;\n}\n\n\n/*font-szes*/\n.extraLarge {\n  font-size: $extraLarge;\n  /*28px*/\n}\n\n.large2 {\n  font-size: $large2;\n  /*22px*/\n}\n\n.large {\n  font-size: $large;\n  /*18px*/\n}\n\n.normal {\n  font-size: $normal;\n  /*16px*/\n}\n\n.medium {\n  font-size: $medium;\n  /*14px*/\n}\n\n.small {\n  font-size: $small;\n  /*12px*/\n}","@use '../../../../styles/colors' as colors;\n@use '../../../../styles/fonts' as fonts;\n\n.dropbtn {\n    font-size: fonts.$large;\n    border: none;\n    background-color: transparent;\n    padding-left: 0.03em;\n    padding-right: 0.03em;\n\n    position: relative;\n    max-width: fit-content;\n    margin: 0;\n}\n\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    right: 0;\n    background-color: colors.$white;\n    min-width: max-content;\n    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n    z-index: 1;\n    min-width: 400px;\n    padding: 2rem;\n    margin-left: 0;\n    margin-right: 0;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.dropdown-content a {\n    color: black;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n.dropdown-content a:hover {\n    background-color: #f1f1f1\n}\n\n.dropdown:hover .dropdown-content {\n    display: flex;\n}\n\n\n.dropdown:hover .dropbtn {\n    display: flex;\n}\n\n.user-initials-profile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n\n    height: 3.5rem;\n    width: 3.5rem;\n\n    font-size: fonts.$large2;\n\n    border-radius: 50%;\n    background-color: #0b2d71;\n    color: colors.$light-blue;\n}\n\n.dropdown>button:after {\n    display: none;\n}\n\n.profile-box-container {\n    width: auto;\n }\n\n.profile-box-image {\n    float: left; \n} \n\n.profile-box-content {\n    padding-left: 1rem;\n} \n\n","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
